import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import MembershipPoolsList from './MembershipPoolsList';
import translate from 'components/hoc/translate';
import Title from 'components/ui/general/Title';

const MembershipPoolsListContainer = (props) => {
    const { resource, translate } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('menu.sidebar.membership_pools') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <MembershipPoolsList { ...props } />
        </div>
    );

};

MembershipPoolsListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(MembershipPoolsListContainer);


// WEBPACK FOOTER //
// ./src/pages/membership-pools/list/MembershipPoolsListContainer.js